import React, { Component } from "react";
import styles from "./Journey.module.scss";
import LegCollection from "../LegCollection";
import DOMPurify from "dompurify";
import {
  Walk,
  Ferry,
  CableCar,
  Rail,
  Bus,
  Tram,
  Underground,
  ChevronRight,
  Drive,
  Park,
  Cycle,
  CycleDock,
  Destination,
  Plane,
  EvStation,
  Alert,
} from "../../utils/index";
import PlayIcon from "../../components/assets/play-button.png";
import PauseIcon from "../../components/assets/pause-button.png";
import { FormattedMessage } from "react-intl";
import { ThemeContext } from "../../Context/ThemeContext";
import { Context as LanguageContext } from "../../Context/LanguageContext";
import AdditionalServiceButton from "../../components/AdditionalService/AdditionalServiceButton";
import Advertisement from "../../components/Advertisement";
import { ReactComponent as Taxi } from "../assets/additional_service_taxi.svg";
import { ReactComponent as Carbon } from "../assets/carbon-world.svg";

class Journey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      arrivalTime: new Date(),
      departureTime: new Date(),
      itinerary: [],
      animateLegs: false,
      isButtonHovered: false,
      restServicePost: this.props.restServicePost,
    };
  }

  setAnimateLegs = (shouldAnimateLegs) => {
    this.setState({ animateLegs: shouldAnimateLegs });
  };

  toggleSelection = () => {
    this.props.toggleSelection();
  };

  toggleRequestAssistance = (travelForecastId) => {
    this.props.toggleRequestAssistance(travelForecastId);
  };

  handleLegUpdateClicked = (updatedLegs) => {
    this.props.onLegUpdateClicked(updatedLegs);
  };

  toggleHighlight = () => {
    this.props.setAlertsButton(false);
    if (this.props.journey.legs.length > 0) {
      this.props.toggleHighlightedJourney(this.props.journey.order);
      this.props.onJourneyClicked(this.props.journey.legs);
    }
  };

  toggleMoreOptions = () => {
    if (this.props.subJourneysExpanded) {
      this.props.toggleActiveJourney(null);
    }
    this.props.setJourneysExpanded(
      this.props.journey.id,
      !this.props.subJourneysExpanded
    );
  };

  toggleClass = () => {
    this.props.journey.active = !this.props.journey.active;
    if (this.props.journey.active === false) {
      this.props.toggleActiveJourney(null);
    } else {
      this.props.toggleActiveJourney(this.props.journey.order);
    }
  };

  componentDidMount = () => {
    this.checkAndUpdateServiceProviderCode();
    var itinerary = [];
    const legsCount = this.props.journey.legs.length - 1;
    if (this.props.journey.order === this.props.activeJourney) {
      this.props.toggleHighlightedJourney(this.props.journey.order);
    }

    var disruptionMessages =
      this.props.journey.legs?.flatMap((leg) => leg.disruptionMessages) ?? [];

    if (disruptionMessages && disruptionMessages.length > 0) {
      itinerary.push(
        <span>
          <Alert
            className={styles["Alert"]}
            onClick={() => {
              this.props.toggleDisruptionsModal(
                !this.props.displayDisruptionsModal,
                disruptionMessages
              );
            }}
          />
        </span>
      );
    }

    // Irrespective of the legs cycle mode, if it is in a "cycledock" journey, show that icon.
    const formattedLegs = this.props.journey.legs.map((leg) => {
      if (
        this.props.journey.mode === "cycledock" &&
        leg.mode.toLowerCase().includes("cycle")
      ) {
        leg.mode = "CycleDock";
      }
      return leg;
    });

    formattedLegs.forEach((leg, index) => {
      if (legsCount !== index) {
        itinerary.push(
          {
            Walk: (
              <span key={index}>
                <Walk
                  className={styles["Walk"]}
                  alt="Map marker indicating transport mode walk"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Rail: (
              <span key={index}>
                <Rail
                  className={styles["Rail"]}
                  alt="Map marker indicating transport mode train or rail"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Bus: (
              <span key={index}>
                <Bus
                  className={styles["Bus"]}
                  alt="Map marker indicating transport mode bus"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            ReplacementBus: (
              <span key={index}>
                <Bus
                  className={styles["Bus"]}
                  alt="Map marker indicating transport mode bus"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Ferry: (
              <span key={index}>
                <Ferry
                  className={styles["Ferry"]}
                  alt="Map marker indicating transport mode ferry"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            CableCar: (
              <span key={index}>
                <CableCar className={styles["CableCar"]} />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Tram: (
              <span key={index}>
                <Tram className={styles["Tram"]} />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Coach: (
              <span key={index}>
                <Bus
                  className={styles["Coach"]}
                  alt="Map marker indicating transport mode coach"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Metro: (
              <span key={index}>
                <Tram
                  className={styles["Metro"]}
                  alt="Map marker indicating transport mode metro"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Underground: (
              <span key={index}>
                <Underground
                  className={styles["Underground"]}
                  alt="Map marker indicating transport mode underground"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Drive: (
              <span key={index}>
                <Drive
                  className={styles["Drive"]}
                  alt="Map marker indicating transport mode drive"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            // use Drive icon for now
            ElectricVehicle: (
              <span key={index}>
                <Drive
                  className={styles["Drive"]}
                  alt="Map marker indicating transport mode electric vehicle"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Park: (
              <span key={index}>
                <Park
                  className={styles["Park"]}
                  alt="Map marker indicating transport mode park"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            EvStation: (
              <span key={index}>
                <EvStation
                  className={styles["EvStation"]}
                  alt="Map marker indicating transport mode EV station"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            CycleDock: (
              <span key={index}>
                <CycleDock
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode cycle dock"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Cycle: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode cycle"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            CycleStreetsQuietest: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode quietest cycle"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            CycleStreetsFastest: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode fastest cyle"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            CycleStreetsBalanced: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode balanced cycle"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            CycleStreetsDefault: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode cycle"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Destination: (
              <span key={index}>
                <Destination
                  className={styles["Destination"]}
                  alt="Map marker indicating the destination"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Flight: (
              <span>
                <Plane
                  className={styles["Plane"]}
                  alt="Map marker indicating transport mode flight"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
          }[leg.mode]
        );
      } else {
        itinerary.push(
          {
            Walk: (
              <span key={index}>
                <Walk
                  key={index}
                  className={styles["Walk"]}
                  alt="Map marker indicating transport mode walk"
                />
              </span>
            ),
            Rail: (
              <span key={index}>
                <Rail
                  key={index}
                  className={styles["Rail"]}
                  alt="Map marker indicating transport mode train or rail"
                />
              </span>
            ),
            Bus: (
              <span key={index}>
                <Bus
                  key={index}
                  className={styles["Bus"]}
                  alt="Map marker indicating transport mode bus"
                />
              </span>
            ),
            Ferry: (
              <span key={index}>
                <Ferry
                  key={index}
                  className={styles["Ferry"]}
                  alt="Map marker indicating transport mode ferry"
                />
              </span>
            ),
            CableCar: (
              <span key={index}>
                <CableCar
                  key={index}
                  className={styles["CableCar"]}
                  alt="Map marker indicating transport mode cable car"
                />
              </span>
            ),
            Tram: (
              <span key={index}>
                <Tram
                  key={index}
                  className={styles["Tram"]}
                  alt="Map marker indicating transport mode tram"
                />
              </span>
            ),
            Coach: (
              <span key={index}>
                <Bus
                  key={index}
                  className={styles["Coach"]}
                  alt="Map marker indicating transport mode coach"
                />
              </span>
            ),
            Metro: (
              <span key={index}>
                <Tram
                  key={index}
                  className={styles["Metro"]}
                  alt="Map marker indicating transport mode metro"
                />
              </span>
            ),
            Underground: (
              <span key={index}>
                <Underground
                  key={index}
                  className={styles["Underground"]}
                  alt="Map marker indicating transport mode underground"
                />
              </span>
            ),
            Drive: (
              <span key={index}>
                <Drive
                  key={index}
                  className={styles["Drive"]}
                  alt="Map marker indicating transport mode drive"
                />
              </span>
            ),
            ElectricVehicle: (
              <span key={index}>
                <Drive
                  key={index}
                  className={styles["Drive"]}
                  alt="Map marker indicating transport mode electric vehicle"
                />
              </span>
            ),
            Park: (
              <span key={index}>
                <Park
                  key={index}
                  className={styles["Park"]}
                  alt="Map marker indicating transport mode park"
                />
              </span>
            ),
            EvStation: (
              <span key={index}>
                <EvStation
                  key={index}
                  className={styles["EvStation"]}
                  alt="Map marker indicating transport mode EV station"
                />
              </span>
            ),
            CycleDock: (
              <span key={index}>
                <CycleDock
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode cycle dock"
                />
                <ChevronRight className={styles["ChevronRight"]} />
              </span>
            ),
            Cycle: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode cycle"
                />
              </span>
            ),
            CycleStreetsQuietest: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode quietest cycle"
                />
              </span>
            ),
            CycleStreetsFastest: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode fastest cycle"
                />
              </span>
            ),
            CycleStreetsBalanced: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode balanced cycle"
                />
              </span>
            ),
            CycleStreetsDefault: (
              <span key={index}>
                <Cycle
                  className={styles["Cycle"]}
                  alt="Map marker indicating transport mode cycle"
                />
              </span>
            ),
            Destination: (
              <span key={index}>
                <Destination
                  className={styles["Destination"]}
                  alt="Map marker indicating the destination"
                />
              </span>
            ),
            Flight: (
              <span>
                <Plane
                  className={styles["Plane"]}
                  alt="Map marker indicating transport mode flight"
                />
              </span>
            ),
          }[leg.mode]
        );
      }
    });

    this.setState({
      arrivalTime: new Date(
        this.props.journey.legs[this.props.journey.legs.length - 1].arrivalTime
      ),
      departureTime: new Date(this.props.journey.legs[0].departureTime),
      itinerary: itinerary,
    });
  };

  checkAndUpdateServiceProviderCode = () => {
    const { additionalServices } = this.props.journey;

    if (additionalServices) {
      this.setState({ additionalServices: additionalServices });
    }
  };

  round = (num, places) => {
    return +(Math.round(num + "e+" + places) + "e-" + places);
  };

  handleCarbonClicked = (carbonUrl) => {
    if (!carbonUrl) return;
    window.open(carbonUrl, "_blank");
  };

  renderKCalories = (kCalories) => {
    const roundTo = 0;

    if (!kCalories || this.round(kCalories, roundTo) === 0) {
      return "";
    }

    return this.round(kCalories, roundTo) + " cal";
  };

  renderTime = (journeyDuration) => {
    var timeStr = "";

    if (Math.floor(journeyDuration / 60) === 0) {
      timeStr += "";
    } else {
      timeStr += Math.floor(journeyDuration / 60) + " h";
    }

    if (journeyDuration % 60 === 0) {
      timeStr += "";
    } else {
      timeStr += " " + (journeyDuration % 60) + " min";
    }

    return timeStr;
  };

  renderButtonIcon = (url, category) => {
    if (url) {
      return (
        <img
          src={url}
          alt={`${category} icon`}
          style={{ width: 30, height: "auto" }}
        />
      );
    } else {
      switch (category) {
        case "TAXI":
          return <Taxi alt="Taxi icon" />;
        default:
          return null;
      }
    }
  };

  render() {
    const { itinerary, additionalServices } = this.state;

    const {
      id,
      legs,
      journeyDuration,
      fares,
      active,
      show,
      description,
      localizedDescriptions,
      localizedMessages,
      message,
      highlight,
      thirdPartySource,
      carbonFootprint,
      kCalories,
      mode,
      formattedCarbonValue,
      carbonUrl,
      carbonButtonMessage,
      advertisement,
      isEligible,
      journeyOptionIconUrl,
    } = this.props.journey;

    let thirdPartyActionData = {
      message: message,
      sourceURL: thirdPartySource,
      includeEmail: false,
      description: description,
    };

    //TODO: Encapsulate within DumfriesCouncilAuthProvider method.
    const thirdPartyAlternative = this.props.thirdPartyAlternative
      ? JSON.parse(this.props.thirdPartyAlternative)
      : null;

    // Assign alternative information for not logged in users
    if (thirdPartyAlternative && thirdPartyAlternative.message) {
      thirdPartyActionData.message = thirdPartyAlternative.message;
      thirdPartyActionData.sourceURL = thirdPartyAlternative.sourceURL;
      thirdPartyActionData.includeEmail = thirdPartyAlternative.includeEmail;
    }

    const hasCarbonValues =
      highlight && carbonFootprint && this.round(carbonFootprint, 1) !== 0;

    return (
      <ThemeContext.Consumer>
        {(theme) => (
          <LanguageContext.Consumer>
            {({ locale }) => {
              const displayDescription =
                (localizedDescriptions && localizedDescriptions[locale]) ||
                description;

              const displayMessage =
                (localizedMessages && localizedMessages[locale]) || message;

              const sanitisedMessage = DOMPurify.sanitize(
                displayMessage || "",
                {
                  ADD_ATTR: ["target"],
                }
              );
              return (
                <li
                  onClick={this.toggleHighlight}
                  className={`${styles["Journey"]} ${
                    show ? styles["show"] : styles["hide"]
                  } ${
                    highlight && this.props.selectedLegIndex == null
                      ? styles["highlight"]
                      : styles["fade"]
                  }`}
                  style={{ "--theme-color": theme.theme.primaryColour }}
                >
                  <div
                    className={`${styles["journey-sub"]} ${
                      advertisement ? styles["with-advertisement"] : ""
                    }`}
                    style={{
                      borderColor: "blue",
                    }}
                  >
                    <div
                      className={styles["journey-title-outer-container-full"]}
                    >
                      <div className={styles["journey-title-inner-container"]}>
                        <div className={styles["journey-title"]}>
                          <div className={styles["split-journey-title"]}>
                            <h3
                              id={`journey-title-${this.props.journey.id}`}
                              style={{
                                margin: 0,
                                fontSize: "inherit",
                                fontWeight: "inherit",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              {isEligible && journeyOptionIconUrl ? (
                                <img
                                  src={journeyOptionIconUrl}
                                  alt="Journey option custom icon"
                                  style={{
                                    width: 18,
                                    height: "auto",
                                    marginTop: -3,
                                  }}
                                />
                              ) : null}
                              <span style={{ marginTop: -3 }}>
                                {displayDescription}
                              </span>
                            </h3>
                            <span className={styles["journey-detail-time"]}>
                              {this.renderTime(journeyDuration)}
                            </span>
                          </div>
                          {!thirdPartySource && (
                            <div
                              className={styles["journey-subtitle-container"]}
                            >
                              <span className={styles["journey-subtitle"]}>
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: sanitisedMessage.replace(
                                      /<a\b/g,
                                      `<a style="color: ${theme.theme.primaryColour}; text-decoration: underline; font-weight: bold;"`
                                    ),
                                  }}
                                />
                              </span>
                            </div>
                          )}
                          <div>
                            <div
                              className={
                                styles["split-journey-subtitle-container"]
                              }
                            >
                              <span
                                className={styles["split-journey-subtitle"]}
                              >
                                {itinerary}
                              </span>
                              {!theme?.hideClientElements?.includes(
                                "hideCalorieCount"
                              ) ? (
                                <span
                                  className={styles["journey-detail-kcalories"]}
                                >
                                  {this.renderKCalories(kCalories)}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div>
                            <div
                              data-cy={"parentLeg"}
                              className={`${
                                styles["split-journey-subtitle-container"]
                              } ${
                                this.props.journey.legs.length > 1
                                  ? styles["with-button"]
                                  : ""
                              }`}
                            >
                              <span className={styles["journey-subtitle-a"]}>
                                {this.props.journey.legs.length > 1 &&
                                active ? (
                                  <button
                                    className={styles["play-pause-button"]}
                                    style={{
                                      backgroundColor: !this.state
                                        .isButtonHovered
                                        ? theme.theme.primaryColour
                                        : theme.theme.hoverColour,
                                    }}
                                    onMouseEnter={() => {
                                      this.setState({ isButtonHovered: true });
                                    }}
                                    onMouseLeave={() => {
                                      this.setState({ isButtonHovered: false });
                                    }}
                                    onClick={() => {
                                      if (!active) {
                                        this.toggleClass();
                                      }
                                      this.setAnimateLegs(
                                        !this.state.animateLegs
                                      );
                                      this.props.setTerminateLegAnimation(
                                        false
                                      );
                                    }}
                                  >
                                    {!this.state.animateLegs ? (
                                      <img
                                        src={PlayIcon}
                                        alt="Animate and cycle through journey legs"
                                        className={styles["play-pause-icon"]}
                                      />
                                    ) : (
                                      <img
                                        src={PauseIcon}
                                        alt="Pause animating and cycling through journey legs"
                                        className={styles["play-pause-icon"]}
                                      />
                                    )}
                                  </button>
                                ) : (
                                  ""
                                )}
                                {this.props.journey.legs.length > 0 && (
                                  <button
                                    className={styles["a"]}
                                    style={{
                                      color: theme.theme.primaryColour,
                                    }}
                                    onClick={() => {
                                      this.toggleClass();
                                      this.setAnimateLegs(false);
                                      this.props.setSelectedLegIndex(null);
                                    }}
                                    aria-describedby={`journey-title-${this.props.journey.id}`}
                                    aria-expanded={active}
                                    aria-label={
                                      active
                                        ? `Hide details for ${displayDescription}`
                                        : `Show details for ${displayDescription}`
                                    }
                                  >
                                    {active ? (
                                      <FormattedMessage id="closeDetails" />
                                    ) : (
                                      <FormattedMessage id="showDetails" />
                                    )}
                                  </button>
                                )}
                                {this.props.journey.isParentJourney &&
                                  this.props.journey.active === false && (
                                    <span
                                      style={{
                                        color: theme.theme.primaryColour,
                                      }}
                                    >
                                      &nbsp;&nbsp;&#124;&nbsp;&nbsp;
                                      <button
                                        className={styles["a"]}
                                        style={{
                                          color: theme.theme.primaryColour,
                                        }}
                                        onClick={() => {
                                          this.toggleMoreOptions();
                                        }}
                                        aria-describedby={`journey-title-${this.props.journey.id}`}
                                        aria-expanded={
                                          this.props.subJourneysExpanded
                                        }
                                        aria-label={
                                          this.props.subJourneysExpanded
                                            ? `Hide alternative options for ${displayDescription}`
                                            : `Show alternative options for ${displayDescription}`
                                        }
                                      >
                                        {this.props.subJourneysExpanded ? (
                                          <FormattedMessage id="fewerOptions" />
                                        ) : (
                                          <FormattedMessage id="moreOptions" />
                                        )}
                                      </button>
                                    </span>
                                  )}
                              </span>
                              {theme?.hideClientElements.length > 0 &&
                              theme.hideClientElements?.includes("hideCO2e") ? (
                                ""
                              ) : (
                                <>
                                  <span
                                    style={{
                                      color: theme.theme.primaryColour,
                                    }}
                                    className={
                                      styles["journey-detail-carbon-unselected"]
                                    }
                                    onClick={() => {
                                      if (!hasCarbonValues) return;
                                      if (
                                        !theme?.carbonRemovalValues
                                          ?.hasCarbonValues
                                      )
                                        return;
                                      this.handleCarbonClicked(carbonUrl);
                                    }}
                                  >
                                    {formattedCarbonValue}
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                          {hasCarbonValues &&
                          theme?.carbonRemovalValues?.showCarbonButton ? (
                            <div
                              style={{
                                display: "inline-flex",
                                width: "101.5%",
                                marginTop: "4px",
                              }}
                            >
                              <AdditionalServiceButton
                                key={0}
                                icon={
                                  <Carbon alt="Offset your carbon emissions" />
                                }
                                text={carbonButtonMessage}
                                onClick={() => {
                                  if (!hasCarbonValues) return;
                                  this.handleCarbonClicked(carbonUrl);
                                }}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {highlight && additionalServices?.length > 0 && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "101.5%",
                              }}
                            >
                              {additionalServices.map((service, index) => {
                                const displayLabelText =
                                  (service.localizedLabelTexts &&
                                    service.localizedLabelTexts[locale]) ||
                                  service.labelText;
                                return (
                                  <AdditionalServiceButton
                                    key={index + 1}
                                    icon={this.renderButtonIcon(
                                      service.buttonIconUrl,
                                      service.category
                                    )}
                                    text={`${displayLabelText}`}
                                    disabled={service.disabled}
                                    {...(service.baseUrl ===
                                    "onClickOverrideSustainability"
                                      ? {
                                          onClick: () => {
                                            this.props.loginOrSaveTravelForecast(
                                              id
                                            );
                                          },
                                        }
                                      : { link: () => service.baseUrl })}
                                  />
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  {highlight && advertisement && (
                    <Advertisement
                      imageUrl={advertisement.imageUrl}
                      text={advertisement.text}
                      clickUrl={advertisement.clickUrl}
                      mode={advertisement.mode || "journey"}
                    />
                  )}
                  <LegCollection
                    active={active}
                    legs={legs}
                    fares={fares}
                    animateLegs={this.state.animateLegs}
                    setAnimateLegs={this.setAnimateLegs}
                    onJourneyLegClicked={this.props.onJourneyLegClicked}
                    onLegUpdateClicked={this.handleLegUpdateClicked}
                    enableNavigation={this.props.enableNavigation}
                    apiToken={this.props.apiToken}
                    toggleSelection={this.toggleSelection}
                    showTravelPlan={this.props.showTravelPlan}
                    travelForecast={this.props.travelForecast}
                    toggleRequestAssistance={this.toggleRequestAssistance}
                    auth={this.props.auth}
                    showInfoPopup={this.props.showInfoPopup}
                    setInitialViewPort={this.props.setInitialViewPort}
                    terminateLegAnimation={this.props.terminateLegAnimation}
                    setTerminateLegAnimation={
                      this.props.setTerminateLegAnimation
                    }
                    toggleDirectionsModal={this.props.toggleDirectionsModal}
                    toggleIntermediateStopsModal={
                      this.props.toggleIntermediateStopsModal
                    }
                    isIntermediateStopsVisible={
                      this.props.isIntermediateStopsVisible
                    }
                    setSelectedLegIndex={this.props.setSelectedLegIndex}
                    allowEditTime={mode !== "publictransport"}
                  />
                </li>
              );
            }}
          </LanguageContext.Consumer>
        )}
      </ThemeContext.Consumer>
    );
  }
}

export default Journey;
